const lan = {
  REDIRECT: "Přesměrovávám...",
  RULE: {
    SERVICE_TYPE: "Vyberte typ služby, prosím",
    COUNTRY: "Prosím, vyberte zemi nebo region",
    USERNAME: "Uživatelské jméno je požadováno",
    EMAIL: "E-mail je povinný",
    EMAIL2: "Zadejte prosím správný formát e-mailu.",
    PRODUCT: "Vyberte prosím vaše zařízení",
    PRODUCTSN: "Zadejte sériové číslo Vašeho produktu",
    PRODUCTSN_LEN: "Zadejte 12 až 15 písmen nebo čísel",
    BIRTHDAY: "Datum narození je povinné",
    REQUIRED: "Povinné",
  },
  SYS: {
    HEAD: "Systém",
    NOSERVICE:
      "Omlouváme se, ASUS Chat pro zvolenou zemi, nebo region není k dispozici.",
    CHECK_FILESIZE:
      "Zkontrolujte velikost obrázku, nebo přílohy souboru. Limit:",
    RECONNECTED: "Stav připojení se vrátil do normálu",
    UNABLE_SEND: "Přílohu nelze nahrát.",
    NO_NETWORK: "Nejste připojeni k Internetu",
    NO_NETWORK_INFO:
      "Nejste připojeni k Internetu. Ověřte prosím připojení a zkuste to znovu.",
  },
  IDLE: {
    HEAD: "Momentálně jste v nečinnosti. Přejete si pokračovat v konverzaci?",
    BUTTON: "Pokračovat",
  },
  DISCONNECT: {
    HEAD: "Chat byl ukončen",
    BUTTON: "Ukončit",
  },
  LAYOUT: {
    STEP_1: "Vyberte produkt",
    STEP_2: "Podmínky použití",
    STEP_3: "Přihlášení",
    STEP_4: "Informace",
    SELECT_SKILL: "Vyberte produkt",
    PREV_STEP: "Předchozí",
    NEXT_STEP: "Další",
    NOTSET: "Nenastaveno.",
    AGREEN: "Přijmout",
    NOTAGREEN: "Odmítnout",
    LEAVE: "Odejít",
    TYPE_HERE: "Pište zde",
    CHAT_DOWNLOAD:
      "Klikněte zde pro uložení kopie Vašeho chatu s ASUS Online Zákaznickým servisem.",
  },
  COUNTRY: { SELECT_COUNTRY: "Prosím, vyberte zemi nebo region" },
  POLICY: {
    PRIVACY: "Zásady ochrany soukromí",
    SAT_SURVEY: "Souhlas s podmínkami",
    CONFIRM_COUNTRY: {
      H1: "Vážený zákazníku ASUS,",
      P1:
        'Nyní vstupujete na "Online zákaznický servis ASUS", který se liší od vašeho aktuálního regionu. Podle záručních podmínek společnosti ASUS se ne na každý produkt ASUS vztahuje mezinárodní záruka a podpora společnosti ASUS. Pokud výše uvedená regionální stránka, kterou navštěvujete, není regionem, kde jste produkt ASUS zakoupili, nebo se liší od vašeho aktuálního regionu, může to mít vliv na vaše práva. I nadále můžete používat "Online zákaznický servis ASUS", nebo zvolit "Online zákaznický servis ASUS" pro váš region.',
      P2: "",
      P3: "",
      B1: "Přejít na ASUS",
      B2: "Webové stránky",
      B3: "Pokračovat",
    },
    BULLETIN: {
      HEAD: "Oznámení o důležité zprávě",
      CONFIRM: "Rozumím",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Vyplňte kontaktní údaje, prosím",
    SURVEY_TYPE: "Vyberte typ služby, prosím",
    PROBLEM_BRIEF: "Jak byste popsali svůj problém?",
    TYPE1: "Obecný dotaz",
    TYPE2: "Dotaz k opravě",
    TYPE3: "Technická podpora",
    TYPE4: "Ověření záruky",
    TYPE5: "Názory a zpětná vazba",
    EC_TYPE1: "Informace o produktech a prodeji",
    EC_TYPE2: "Marketingová akce",
    EC_TYPE3: "Stav dodání a objednávky",
    EC_TYPE4: "Služba vrácení",
    SIGNUPDATA: "Vaše registrační údaje",
    NAME: "Jméno",
    TEL: "Telefonní číslo",
    ORDER_NO: "Order No.",
    BIRTHDAY: "Datum narození",
    LABEL_EMAIL: "Email",
    EMAIL: "Email",
    DEVICEINFO: "Informace o Vašem výrobku",
    DEVICENAME: "Název produktu",
    MY_DEVICE: "Your Product",
    MY_DEVICE_SELECT: "Select Your Product",
    MY_DEVICE_EMPTY: "You don't have any devices yet.",
    LABEL_DEVICESN: "Sériové číslo",
    DEVICESN: "Výrobní číslo produktu",
    DEVICESN_ERROR: "Zadané číslo je neplatné.",
    PREPARE: "Vytvoření chatovací místnosti, příprava na chatování",
    START: "Zahájit chat",
    AGE_LIMIT: "Věková hranice",
    AGE_LIMIT_DESC:
      "Nesplňujete věkové požadavky, abyste mohli používat ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Zjištěna existující chatovací místnost",
      P1:
        "Opravdu chcete zahájit novou konverzaci? Když bude otevřena nová konverzace, stará konverzace bude ukončena.",
      B0: "Potvrdit",
      B1: "Zrušit",
    },
  },
  CONNECTTING: {
    P1: "Počkejte prosím chvíli a nezavírejte chatovací okno",
    P2: "Systém Vás spojuje s dostupným agentem",
    NOTE: "Nápověda",
    BEFORE_LEAVE: "Jste si jisti, že chcete ukončit tento ASUS chat?",
    B0: "Ukončit",
    B1: "Zůstat a počkat",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Kontaktujte ASUS prostřednictvím jiných kanálů",
    MAIL: "Napište nám",
    TEL: "Zavolejte nám",
    CLOSE: "Uzavřít",
  },
  WAITTING: {
    WATTING_NUM: "Pozice ve frontě",
    PEOPLE: "Zákazník",
    NOTE: "Nápověda",
    BEFORE_LEAVEL: "Opravdu chcete opustit frontu?",
    LEAVE_DESC: "Pokud již nechcete ve frontě, můžete ukončit chat",
    LEAVE: "Ukončení chatu",
    STAY: "Zůstat ve frontě",
  },
  CHATROOM: {
    TYPING: "Agent píše...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Ukončit chat",
      TERMINATE: "Ukončení chatu",
    },
    FOOTER: { CHAT_FINISH: "Chat byl ukončen" },
    FINISH: "Chat byl ukončen. Potřebujete nějakou další službu nebo podporu?",
    SAT_SURVEY: {
      SAT: "Spokojen/á",
      DISSAT: "Nespokojen/á",
      SAT_CHOOSE: "Jaký typ služeb? (Více možností volby)",
      HEAD: "Byli jste spokojeni s chatem?",
      DESC:
        "Vaše zpětná vazba je pro nás hnací silou pro neustálé zlepšování. Pokud máte nějaké návrhy pro servis nebo podporu společnosti ASUS, dejte nám prosím vědět.",
      OTHER_OPTION: "Jiné",
      OTHER_REASON: "Vyplňte jiný důvod, prosím",
      SEND: "Odeslat",
    },
    CLOSE: {
      TITLE: "Jste si jisti, že chcete ukončit chat?",
      P1:
        'Kliknutím na tlačítko "Ukončit" zavřete okno. Pokud budete chtít chat znovu použít, bude nutné znovu požádat o chat".',
      B0: "Ukončit",
      B1: "Zrušit",
    },
  },
  ERROR: {
    H1: "Chatovací místnost neexistuje nebo byl chat již ukončen",
    CLOSE: "Zavřít okno",
  },
  CHAT_END: {
    H1: "Děkujeme mnohokrát, chat byl ukončen",
    CLOSE: "Zavřít okno",
  },
  CHAT_CLOSE: {
    H1:
      "Vaše síť byla nefunkční déle než 300 sekund, proto jsme tuto konverzaci ukončili.",
    DESC:
      "Pokud používáte bezdrátovou síť nebo mobilní síť, zkuste najít místo s lepším signálem; nebo přepněte na pevné síťové připojení. Omlouváme se za nepříjemnosti.",
    CLOSE: "Zavřít okno",
  },
  SURVEY_DONE: {
    H1: "Děkujeme. Dokončili jste průzkum spokojenosti",
    P1:
      'Vaše zpětná vazba je hnací silou pro naše neustálé zlepšování. Děkujeme, že jste si našli čas na vyplnění dotazníku spokojenosti se službami. Pokud budete potřebovat další služby nebo podporu, klikněte na tlačítko "Zahájit nový chat". Pokud jsme váš dotaz vyřešili, klikněte na "Zavřít okno" a ukončete chat.',
    AGAIN: "Zahájit nový chat",
    CLOSE: "Zavřít okno",
    YT_H1: "Objevte tipy a technické dovednosti díky videím podpory ASUS.",
    YT_H2: "Klepnutím prozkoumejte!",
  },
  AGENT_OFFLINE: {
    H1:
      "Internetové připojení agenta nereaguje; Váš chat je v současné době přerušen",
    H2: "Prosím, nezavírejte okno; usilovně pracujeme na obnovení chatu",
    DESC:
      'Můžete také ukončit relaci a provést průzkum nebo kliknout na tlačítko "Zahájit nový chat" a my vám okamžitě přidělíme nového agenta, který bude v relaci pokračovat. Omlouváme se za způsobené nepříjemnosti.',
    AGAIN: "Zahájit nový chat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Nelze používat kameru a mikrofon",
    H1: "Jste připraveni se připojit?",
    P1:
      "Aby vám pracovníci zákaznického servisu společnosti ASUS mohli účinněji pomoci vyřešit problém, musíte zařízení povolit přístup ke kameře a mikrofonu, abyste se mohli připojit k videochatu, a ujistěte se, že připojení k mobilní síti je stabilní a normálně funguje.",
    P2:
      "Po zpřístupnění můžete stále libovolně nastavovat přepínač objektivu a ztlumení mikrofonu.",
    VIDEO_STATE: "Stav videa",
    VIDEO_ON: "Zapnuto",
    VIDEO_OFF: "Vypnuto",
    AUDIO_STATE: "Stav audia",
    AUDIO_ON: "Zapnuto",
    AUDIO_OFF: "Vypnuto",
    ENTER: "Připojit",
    HANGUP: {
      H1: "Zavěsit",
      P1: "Určitě chcete zavěsit videochat?",
      CONFIRM: "Potvrdit",
      CANCEL: "Storno",
    },
    END: {
      H1: "Videohovor byl ukončen",
      P1: "Děkujeme, videochat je u konce, toto okno můžete zavřít.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Vyberte produkt",
      STEP_2: "Podmínky použití",
      STEP_3: "Přihlášení",
      STEP_4: "Informace",
      SELECT_SKILL: "Vyberte produkt",
      WELCOME: "Vítáme Vás",
      AGREE: "Souhlasím",
      START: "Spustit",
      CANCEL: "Zrušit",
      WAIT: "Počkejte prosím",
      INPUT: "Vložit text",
      TRANSFER_TOAGENT: "Přepojení na agenta.",
      READMORE:
        "Můžete se také podívat na následující související časté dotazy, děkujeme.",
      COLLAPSE: "Skrýt",
      INPUT_SN: "Prosím, zadejte znovu sériové číslo",
      YOU_MAY_ALSO: "Možná Vás také zajímá:",
      FOR_FURTHER: "Pro více informací se podívejte na:",
      RECORDING: "Začněte mluvit, prosím...",
      RECORDING_NOT_SUPPORTED:
        "Váš prohlížeč nepodporuje rozpoznávání řeči",
      RECORDING_NOT_FOUND:
        "Nebylo rozpoznáno žádné záznamové zařízení. Zkontrolujte prosím Váš mikrofon a příslušná oprávnění.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "Typ produktu",
      MODEL: "Název produktu",
      SERIALNO: "Sériové číslo produktu",
      STATUS: "Stav záruky",
      DATE: "Datum vypršení záruky",
    },
    HEAD: {
      LEAVE: "Odejít",
      CREATE_NEW: "Vytvoření nové místnosti",
    },
    ENTRANCE: {
      POLICY: "Zásady ochrany osobních údajů",
      AGREE: "Kliknutím na tlačítko Souhlasím zahájíte konverzaci",
    },
    MESSAGE: {
      WAIT: "Počkejte prosím, hledáme pro Vás řešení.",
    },
    END: "Konverzace byla ukončena",
    END_MSG: "Jsme rádi, že Vám můžeme pomoci. Konverzace je skončena.",
    END_SURVEY: "Průzkum spokojenosti",
    END_SURVEY_MSG: "Jsme rádi, že Vám můžeme pomoci. Konverzace je skončena.",
    BACKHOME: "Zpět na domovskou stránku",
    SURVEY: {
      DESC: "Ohodnoťte své zkušenosti s virtuálním asistentem ASUS.",
      SAT: "Spokojen/á",
      DISSAT: "Nespokojen/á",
      FEEDBACK: "Vyplňte prosím svou zpětnou vazbu.",
      SEND: "Odeslat",
      BACK: "Zrušit",
    },
    SURVEY_DISLIKE: {
      H1: "Proč Vás odpověď neuspokojila?",
      P: "Vaše zpětná vazba pomáhá zlepšovat kvalitu našich služeb.。",
      BUTTON: "Odeslat",
    },
    HISTORY: {
      TITLE: "History",
      AGO: "Před {hours} hodinou/hodinami",
      CONTINUE: "Continue Chat",
      CLOSE: "The conversation has been closed.",
      RESTART: "Restart with Virtual Assistant",
      NON_SERVICE: "Non-Service Hours",
      VIEW_HISTORY: "Click to view the latest chat history.",
    },
  },
};
export default lan;
